import { Injectable, inject } from '@angular/core';
import { BaseQueryRepository } from '@okcargo-apps/shared-infrastructure';
import {
  CompanyResponse,
  DocumentMetadataResponse,
  FindCompanyQuery,
  FindCompanyQueryHandler,
  InvoiceBasicResponse,
  InvoiceResponse,
  SearchCarrierDocumentMetadataQuery,
  SearchCarrierDocumentMetadataQueryHandler,
  SearchInvoicesForCarriersQuery,
  SearchInvoicesForCarriersQueryHandler,
  SearchInvoicesForShippersQuery,
  SearchInvoicesForShippersQueryHandler,
  SearchInvoicesQuery,
  SearchInvoicesQueryHandler,
  SearchSitesQuery,
  SearchSitesQueryHandler,
  SiteResponse,
} from '@okcargo/query-processor';

@Injectable({
  providedIn: 'root',
})
export class CompanyQueryService {
  private readonly queryRepository = inject(BaseQueryRepository);

  private readonly searchCarrierDocumentMetadataQueryHandler: SearchCarrierDocumentMetadataQueryHandler;
  private readonly searchInvoicesQueryHandler: SearchInvoicesQueryHandler;
  private readonly searchInvoicesForCarriersQueryHandler: SearchInvoicesForCarriersQueryHandler;
  private readonly searchInvoicesForShippersQueryHandler: SearchInvoicesForShippersQueryHandler;
  private readonly findCompanyQueryHandler: FindCompanyQueryHandler;
  private readonly searchSitesQueryHandler: SearchSitesQueryHandler;

  constructor() {
    const queryRepository = this.queryRepository;

    this.searchCarrierDocumentMetadataQueryHandler = new SearchCarrierDocumentMetadataQueryHandler(queryRepository);
    this.searchInvoicesQueryHandler = new SearchInvoicesQueryHandler(queryRepository);
    this.searchInvoicesForCarriersQueryHandler = new SearchInvoicesForCarriersQueryHandler(queryRepository);
    this.searchInvoicesForShippersQueryHandler = new SearchInvoicesForShippersQueryHandler(queryRepository);
    this.findCompanyQueryHandler = new FindCompanyQueryHandler(queryRepository);
    this.searchSitesQueryHandler = new SearchSitesQueryHandler(queryRepository);
  }

  searchCarrierDocumentMetadata(query: SearchCarrierDocumentMetadataQuery): Promise<DocumentMetadataResponse[]> {
    return this.searchCarrierDocumentMetadataQueryHandler.handle(query);
  }

  searchInvoices(query: SearchInvoicesQuery): Promise<InvoiceResponse[]> {
    return this.searchInvoicesQueryHandler.handle(query);
  }

  searchInvoicesForCarrier(query: SearchInvoicesForCarriersQuery): Promise<InvoiceBasicResponse[]> {
    return this.searchInvoicesForCarriersQueryHandler.handle(query).then((response) => response.items);
  }

  searchInvoicesForShipper(query: SearchInvoicesForShippersQuery): Promise<InvoiceBasicResponse[]> {
    return this.searchInvoicesForShippersQueryHandler.handle(query).then((response) => response.items);
  }

  findCompany(): Promise<CompanyResponse> {
    const query = {} as FindCompanyQuery;
    return this.findCompanyQueryHandler.handle(query);
  }

  findSites(): Promise<SiteResponse[]> {
    const query = {
      criteriaPayload: {
        filters: [],
        order: [],
        pageIndex: 0,
        pageSize: 200,
      } as any,
    } as SearchSitesQuery;
    return this.searchSitesQueryHandler.handle(query);
  }
}
